import { useState, useCallback } from 'react';

export interface ToastMessage {
  id: string;
  type: 'success' | 'error' | 'info' | 'warning';
  title?: string;
  message: string;
  duration?: number;
  action?: { label: string; onClick: () => void };
}

type ToastOptions = Omit<ToastMessage, 'id'>;
interface ShowToast {
  (options: ToastOptions): string;
  (message: string, type?: ToastMessage['type']): string;
}

export const useToast = () => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const showToast = useCallback(((input: ToastOptions | string, legacyType: ToastMessage['type'] = 'info') => {
    const options: ToastOptions = typeof input === 'string'
      ? { message: input, type: legacyType }
      : input;
    const id = `toast-${Date.now()}-${Math.random()}`;
    const newToast: ToastMessage = {
      id,
      ...options,
      duration: options.duration ?? 4000,
    };
    setToasts((prev) => [...prev.slice(-4), newToast]);
    return id;
  }) as ShowToast, []);

  const removeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  return { toasts, showToast, removeToast };
};
